<template>
    <div class="view">
        <h2 v-if="mode === 'CREATE'">Créer un marché</h2>
        <h2 v-if="mode === 'UPDATE'">Modifier un marché</h2>

        <b-form @submit="onSubmit" @reset="onReset" v-if="show" v-bind:validated="formSubmitted">

            <b-col cols="10">

                <b-row align-h="end" v-if="mode === 'UPDATE'">
                    <b-col cols="3">{{ libelles.dateCreation }} : {{ marche.createdDate | formatDate}}</b-col>
                </b-row>
                <b-row align-h="end">
                    <b-col cols="3"><span class="typo-orange">* </span>{{ libelles.champsObligatoires }}</b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group id="input-group-reference" label-for="input-reference">
                            <template v-slot:label>
                                <label-custom
                                        label="Référence"
                                        tooltip="Indiquer le numéro de marché SGP"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-input
                                    id="input-reference"
                                    v-model="marche.reference"
                                    type="text"
                                    maxlength="50"
                                    :trim="true"
                                    required
                            ></b-form-input>
                            <div class="typo-warning"
                                 v-if="marche.reference && marche.reference.length > 15">
                                Attention, la référence dépasse 15 caractères
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-typeMarche" label-for="input-typeMarche">
                            <template v-slot:label>
                                <label-custom
                                        label="Type"
                                        tooltip="Choisir dans le menu déroulant le type de travaux du marché"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-select
                                    id="input-typeMarche"
                                    v-model="marche.typeMarche"
                                    :options="typesMarche"
                                    required
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group id="input-group-ligne" label-for="input-lignes">
                            <template v-slot:label>
                                <label-custom
                                        label="Lignes de métro"
                                        tooltip="Affecter le marché à une ligne de métro"
                                        :required="true">
                                </label-custom>
                            </template>
                            <LigneMarche
                                    id="input-lignes"
                                    :marcheId="marche.id"
                                    v-model="marche.infosLigne">
                            </LigneMarche>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" offset="4" class="typo-warning pb-3" v-if="!isPonderationsValid">
                        La somme des pondérations des lignes doit être égale à 100
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="2">
                        <b-form-group id="input-group-showTranches" label-for="input-showTranches">
                            <template v-slot:label>
                                <label-custom
                                        label="Type de marché"
                                        tooltip="Choisir Unique si le marché comporte une seule tranche ferme sinon choisir Fractionné"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-radio-group
                                    id="input-showTranches"
                                    v-model="showTranches"
                                    :buttons="true"
                                    button-variant="outline-primary"
                                    required>
                                <b-form-radio :value="false">Unique</b-form-radio>
                                <b-form-radio :value="true">Fractionné</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col v-if="showTranches">
                        <b-form-group id="input-group-tranches" label="Tranches" label-for="input-tranches">
                            <TrancheMarche id="input-tranches"
                                           v-model="marche.tranches">
                            </TrancheMarche>
                        </b-form-group>
                    </b-col>
                    <b-col v-if="!showTranches">
                        <b-form-group id="input-group-montantGlobal" label-for="input-montantGlobal">
                            <template v-slot:label>
                                <label-custom
                                        label="Montant global du marché"
                                        tooltip="Montant global du marché"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-input
                                    id="input-montantGlobal"
                                    v-model="montantGlobal"
                                    type="number"
                                    min="0"
                                    step="any"
                                    :trim="true"
                                    required
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col v-if="!showTranches">
                        <b-form-group id="input-group-objectifPme" label-for="input-objectifPme">
                            <template v-slot:label>
                                <label-custom
                                        label="Objectif PME contractualisé (en euros)"
                                        tooltip="Indiquer l'objectif contractualisé de la clause d'accès des TPE/PME (figure dans l'AE)"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-input
                                    id="input-objectifPme"
                                    v-model="objectifPme"
                                    type="number"
                                    min="0"
                                    step="any"
                                    :trim="true"
                                    required
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col v-if="!showTranches">
                        <b-form-group id="input-group-objectifInsertion" label-for="input-objectifInsertion">
                            <template v-slot:label>
                                <label-custom
                                        label="Objectif insertion contractualisé (en heures)"
                                        tooltip="Indiquer l'objectif contractualisé pour la clause d'insertion par l'activité économique (figure dans l'AE)"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-input
                                    id="input-objectifInsertion"
                                    v-model="objectifInsertion"
                                    type="number"
                                    min="0"
                                    step="any"
                                    :trim="true"
                                    required
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group id="input-group-libelleCourt" label-for="input-libelleCourt">
                            <template v-slot:label>
                                <label-custom
                                        label="Libellé court"
                                        tooltip="Indiquer l'intitulé court de marché"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-input
                                    id="input-libelleCourt"
                                    v-model="marche.libelleCourt"
                                    type="text"
                                    maxlength="20"
                                    :trim="true"
                                    required
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-libelleLong" label-for="input-libelleLong">
                            <template v-slot:label>
                                <label-custom
                                        label="Libellé long"
                                        tooltip="Indiquer l'intitulé long du marché"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-input
                                    id="input-libelleLong"
                                    v-model="marche.libelleLong"
                                    type="text"
                                    maxlength="200"
                                    :trim="true"
                                    required
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group id="input-group-groupement" label-for="input-groupement">
                            <template v-slot:label>
                                <label-custom
                                        label="Titulaire / groupement"
                                        tooltip="Indiquer le nom du groupement titulaire du marché"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-input
                                    id="input-groupement"
                                    v-model="marche.groupement"
                                    type="text"
                                    maxlength="100"
                                    :trim="true"
                                    required
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-titulaire" label-for="input-titulaire">
                            <template v-slot:label>
                                <label-custom
                                        label="SIREN du titulaire ou mandataire"
                                        tooltip="Indiquer le SIREN de l'entreprise mandataire du marché"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-input
                                    id="input-titulaire"
                                    v-model="marche.titulaire"
                                    type="text"
                                    maxlength="100"
                                    :formatter="formatSiretSiren"
                                    :trim="true"
                                    required
                            ></b-form-input>
                            <div class="typo-warning" v-if="isSirenInvalid">Attention, le SIREN entré n'est pas
                                constitué de 9 chiffres
                            </div>
                            <b-button type="button" variant="outline-primary" class="mt-1"
                                      v-if="showCreateEntrepriseButton"
                                      @click="createEntreprise">
                                Créer une entreprise
                            </b-button>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group id="input-group-dateDebut" label-for="input-dateDebut">
                            <template v-slot:label>
                                <label-custom
                                        label="Date de début"
                                        tooltip="Indiquer la date de début de marché (cf date de notification)"
                                        :required="true">
                                </label-custom>
                            </template>
                            <DatepickerCustom
                                    v-model="marche.dateDebut"
                                    id="input-dateDebut"
                                    :state="getDatepickerState">
                            </DatepickerCustom>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-dateFin" label-for="input-dateFin">
                            <template v-slot:label>
                                <label-custom
                                        label="Date de fin prévisionnelle"
                                        tooltip="Indiquer la date de fin de marché (cf date de notification + durée)"
                                        :required="true">
                                </label-custom>
                            </template>
                            <DatepickerCustom
                                    v-model="marche.dateFin"
                                    id="input-dateFin"
                                    :state="getDatepickerState">
                            </DatepickerCustom>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" offset="4" class="typo-warning" v-if="isDatesWrongOrder">
                        La date de début doit être antérieure à la date de fin
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-territoire" label-for="input-territoire">
                            <template v-slot:label>
                                <label-custom
                                        label="Structure de délégation"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-select
                                    id="input-territoire"
                                    v-model="marche.territoire"
                                    :options="territoires"
                                    required
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-secteurGeographique" label-for="input-secteurGeographique">
                            <template v-slot:label>
                                <label-custom 
                                        label="Secteur géographique"
                                        :required="true"
                                        >
                                </label-custom>
                            </template>
                              <b-tooltip target="input-group-secteurGeographique"  placement="top" custom-class="tooltip-image">
                                <b-row class="pt-1"><b-col>Merci de déterminer l'arc géographique de référence selon la répartition suivante :</b-col></b-row>
                                <b-row class="pt-1"><b-img :src="require('../../../public/sectorisation_geographique.png')"></b-img></b-row>
                              </b-tooltip>
                            <b-form-select
                                    id="input-secteurGeographique"
                                    v-model="marche.secteurGeographique"
                                    :options="secteursGeographiques"
                                    required
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-territoire-geo" label-for="input-territoire-geo">
                            <template v-slot:label>
                                <label-custom
                                        label="Territoire géographique"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-select
                                    id="input-territoire-geo"
                                    v-model="marche.territoireGeo"
                                    :options="territoires"
                                    required
                            ></b-form-select>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-direction" label-for="input-direction">
                            <template v-slot:label>
                                <label-custom
                                        label="Direction prescriptrice principale"
                                        :required="false">
                                </label-custom>
                            </template>
                            <b-form-select
                                    id="input-direction"
                                    v-model="marche.directionPrescriptricePrincipale"
                                    :options="directions"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>  
                    <b-col cols="2">
                        <b-form-group id="input-group-termine" label-for="input-termine" label="Marché terminé" label-class="typo-required-field">
                            <b-form-radio-group
                                    id="input-termine"
                                    v-model="marche.termine"
                                    :buttons="true"
                                    button-variant="outline-primary"
                                    required>
                                <b-form-radio :value="false">Non</b-form-radio>
                                <b-form-radio :value="true">Oui</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-form-group id="input-group-commentaire" label-for="input-commentaire">
                      <template v-slot:label>
                        <label-custom
                            label="Commentaire"
                            :required="false">
                        </label-custom>
                      </template>
                      <b-form-textarea
                          id="input-commentaire"
                          v-model="marche.commentaire"
                          rows="3"
                          max-rows="5"
                      ></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-modal
                        id="modal-confirm-edit"
                        title="Modification de la fiche marché"
                        ok-title="Confirmer"
                        cancel-title="Annuler"
                        @ok="update">
                    <p>Confirmez-vous la modification de cette fiche marché ?</p>
                </b-modal>
                <b-button type="submit" variant="primary" @click="formSubmitted = true">Soumettre</b-button>
                <b-button v-if="mode !== 'UPDATE'" type="reset" variant="danger">Réinitialiser</b-button>
            </b-col>

        </b-form>
        <br/>
    </div>

</template>

<script>
  import MarcheDto from "../../dtos/MarcheDto";
  import MarcheStore from "../../stores/MarcheStore";
  import SaveFormEntrepriseStore from "../../stores/SaveFormEntrepriseStore";
  import EntrepriseStore from "../../stores/EntrepriseStore";
  import TypeMarcheStore from "../../stores/TypeMarcheStore";
  import AlertStore from "../../stores/AlertStore";
  import DatepickerCustom from "../../components/DatepickerCustom";
  import LigneMarche from "../../components/marche/LigneMarche";
  import TrancheMarche from "../../components/marche/TrancheMarche";
  import MarcheTrancheDto from "../../dtos/MarcheTrancheDto";
  import {REGEX_SIREN} from "../../constants/regex";
  import formatSiretSiren from "../../filters/formatSiretSiren";
  import LabelCustom from "../../components/LabelCustom";
  import {SecteurGeographiqueEnum} from "../../constants/enums";
  import TerritoireStore from "../../stores/TerritoireStore";
  import {libelles} from '../../constants/libelles';
  import DirectionPresciptricePrincipaleStore from '../../stores/DirectionPrescriptricePrincipaleStore';

  export default {
    components: {LabelCustom, TrancheMarche, LigneMarche, DatepickerCustom},
    data() {
      return {
        formSubmitted: false,
        show: true,
        showCreateEntrepriseButton: false,
        marche: new MarcheDto(),
        showTranches: false,
        objectifPme: null,
        objectifInsertion: null,
        montantGlobal: null,
        typesMarche: [],
        secteursGeographiques: Object.entries(SecteurGeographiqueEnum).map(value => {
          return {text: value[1], value: value[0]}
        }),
        territoires: [],
        libelles: libelles,
        directions: []
      }
    },
    computed: {
      mode() {
        return !this.$route.params.id ? 'CREATE' : 'UPDATE';
      },
      isDatesFilled() {
        return this.marche.dateDebut != null && this.marche.dateFin != null;
      },
      isDatesWrongOrder() {
        return this.isDatesFilled && this.marche.dateDebut > this.marche.dateFin;
      },
      getDatepickerState() {
        return this.formSubmitted ? !this.isDatesWrongOrder && this.isDatesFilled : null;
      },
      isPonderationsValid() {
        const sommePonderation = this.marche.infosLigne.reduce((acc, currentVal) => {
          return currentVal.ponderation != null ? acc + Number(currentVal.ponderation) : acc;
        }, 0);
        return this.marche.infosLigne.length > 0 ? sommePonderation === 100 : true;
      },
      isSirenInvalid() {
        const regex = RegExp(REGEX_SIREN);
        return this.marche.titulaire && !regex.test(this.marche.titulaire);
      }
    },
    watch: {
      $route() {
        this.initMarche();
      }
    },
    mounted() {
      TypeMarcheStore.getAll().then(
          response => this.typesMarche = response.map(value => {
            return {text: value.libelle, value: value};
          })
      );
      TerritoireStore.getAll().then(
          response => this.territoires = response.map(value => {
            return {text: value.libelle, value: value};
          })
      );
      DirectionPresciptricePrincipaleStore.getAll().then(
        response => this.directions = response.map(value => {
          return {text: value.libelle, value: value};
        })
      );
      this.initMarche();
    },
    methods: {
      initMarche() {
        this.formSubmitted = false;
        this.show = false;
        this.showCreateEntrepriseButton = false;
        this.$nextTick(() => {
          this.show = true
        });
        if (this.mode === 'UPDATE') {
          MarcheStore.get(this.$route.params.id).then(value => {
            if (value) {
              this.marche = value;
              this.initTranches();
            }
          });
        } else {
          if (SaveFormEntrepriseStore.state.active) {
            this.marche = SaveFormEntrepriseStore.state.form;
            this.marche.titulaire = SaveFormEntrepriseStore.state.data.siren;
            SaveFormEntrepriseStore.clear();
          } else {
            this.marche = new MarcheDto();
          }
          this.initTranches();
        }
      },
      initTranches() {
        this.showTranches = this.marche.tranches.length > 1;
        if (this.marche.tranches.length === 1) {
          this.montantGlobal = this.marche.tranches[0].montantGlobal;
          this.objectifPme = this.marche.tranches[0].objectifPme;
          this.objectifInsertion = this.marche.tranches[0].objectifInsertion;
        } else if (this.marche.tranches.length === 0) {
          this.objectifPme = null;
          this.objectifInsertion = null;
        }
      },
      formatSiretSiren(value) {
        return formatSiretSiren(value);
      },
      createEntreprise() {
        SaveFormEntrepriseStore.state.active = true;
        SaveFormEntrepriseStore.state.route = this.$route;
        SaveFormEntrepriseStore.state.form = this.marche;
        window.scrollTo(0, 0);
        this.$router.push("/entreprises/creation");
      },
      onSubmit(evt) {
        evt.preventDefault();
        if (this.getDatepickerState && this.isPonderationsValid) {
          if (!this.showTranches) {
            const defaultTranche = new MarcheTrancheDto();
            defaultTranche.libelle = 'Marché unitaire';
            defaultTranche.objectifPme = this.objectifPme;
            defaultTranche.objectifInsertion = this.objectifInsertion;
            defaultTranche.montantGlobal = this.montantGlobal;
            defaultTranche.validee = true;
            this.marche.tranches = [defaultTranche];
          }
          EntrepriseStore.existsBySiren(this.marche.titulaire).then(value => {
            if (value) {
              if (this.mode === 'CREATE') {
                MarcheStore.create(this.marche);
              } else {
                this.$bvModal.show('modal-confirm-edit');
              }
            } else {
              AlertStore.pushError('Le SIREN titulaire n\'existe pas dans le référentiel entreprises');
              this.showCreateEntrepriseButton = true;
              const el = document.getElementById('input-group-titulaire');
              el.scrollIntoView();
            }
          });
        }
      },
      update() {
        MarcheStore.update(this.marche);
      },
      onReset(evt) {
        evt.preventDefault();
        SaveFormEntrepriseStore.clear();
        this.initMarche();
      },
    }
  }
</script>

